module.exports = __webpack_public_path__ + "static/media/map-pin-white-dot-small.c8f82cfa.svg";